//=================================================
//    summary: DCP 選擇 Assignment單元 視窗 -- Hook
//    remarks: 000 Tim 2021/11/10 Create
//             001 Tim 2021/12/23 Fix Bug 第一次assign考卷有選過lesson1的話，第二次進入，雖然assign的單元沒有選，submit後會自動預設在第一課
//                                加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssChooseAssignment from './ChooseAssignment.module.scss'
import './ChooseAssignment.css'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import {GlobalLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false

let mstrBookSeqNo = ""
let marrLessonList = []
let marrPracticeButton = []
let marrReviewButton = []
// #endregion Member Variables

// #region Enumeration
const SectionTypeEnum = {
    "SubSection": 1,
    "SubSubSection": 2
}

const AssignmentTypeEnum = {
    "Practice": 1,
    "Review": 2,
    "Announcement": 3
}
// #endregion Enumeration

const COMP_NAME = "ChooseAssignment"

function ChooseAssignment(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [lessonIndex, setLessonIndex] = useState(0)
    const [isButtonCheck, setIsButtonCheck] = useState(false)
    const [anchorEl4Lesson, setAnchorEl4Lesson] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefLessonDropdown = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrBookSeqNo = window.gSession.App.BookSeqNo.toString().PadLeft(2)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            marrLessonList = []
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowChooseAssignment"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 單元 元件
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ButtonUnitOnTapHandler(SectionType, ButtonIndex)
    {
        console.log(COMP_NAME +  ".ButtonUnitOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let intIndex = 0
        let intCount = 0
        let blnIsCheck = false

        if (SectionType === AssignmentTypeEnum.Practice)
        {
            blnIsCheck = marrPracticeButton[ButtonIndex].IsCheck

            intCount = marrPracticeButton.length

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                marrPracticeButton[intIndex].IsCheck = false
            }

            intCount = marrReviewButton.length

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                marrReviewButton[intIndex].IsCheck = false
            }

            marrPracticeButton[ButtonIndex].IsCheck = !blnIsCheck
        }
        else
        {
            blnIsCheck = marrReviewButton[ButtonIndex].IsCheck

            intCount = marrPracticeButton.length

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                marrPracticeButton[intIndex].IsCheck = false
            }

            intCount = marrReviewButton.length

            for (intIndex = 0; intIndex < intCount; intIndex++)
            {
                marrReviewButton[intIndex].IsCheck = false
            }

            marrReviewButton[ButtonIndex].IsCheck = !blnIsCheck
        }

        setIsButtonCheck(!blnIsCheck)
        setUpdateDataTime(new Date().getTime())
    } // end of ButtonUnitOnTapHandler

    /*===========================================
    summary: 點選 確認
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ConfirmOnTapHandler(StateLessonIndex)
    {
        console.log(COMP_NAME + ".ConfirmOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let intIndex = 0
        let intCount = 0
        let blnFound = false
        let objButton = null
        let intSectionType = -1

        intCount = marrPracticeButton.length

        while ((!blnFound) && (intIndex < intCount))
        {
            if (marrPracticeButton[intIndex].IsCheck)
            {
                objButton = marrPracticeButton[intIndex]
                intSectionType = AssignmentTypeEnum.Practice
                blnFound = true
            }
            intIndex++
        } // end of while

        if (objButton === null)
        {
            intIndex = 0
            intCount = marrReviewButton.length

            while ((!blnFound) && (intIndex < intCount))
            {
                if (marrReviewButton[intIndex].IsCheck)
                {
                    objButton = marrReviewButton[intIndex]
                    intSectionType = AssignmentTypeEnum.Review
                    blnFound = true
                }
                intIndex++
            } // end of while
        } // end of if (objButton !== null)

        if (
            (objButton !== null) &&
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let strSectionName = ""
            if (intSectionType === AssignmentTypeEnum.Practice)
            {
                strSectionName = window.gAppUI.LBL_Practice
            }
            else
            {
                strSectionName = window.gAppUI.LBL_Review
            }

            let objCallbackData = {
                "Action": "ConfirmOnTap",
                "LessonIndex": StateLessonIndex - 1,    // 第一個是預設 Not Select，所以要扣掉
                "LUCatSeqNo": objButton.LUCatSeqNo,
                "LUName": objButton.DisplayName,
                "SectionName": strSectionName,
                "SectionType": intSectionType
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of ConfirmOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    // ====== BEGIN Lesson下拉選單 ======
    /*===========================================
    summary: 點選 Lesson 選單
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function LessonDropdownOnTapHandler(event, StateLessonIndex)
    {
        console.log(COMP_NAME + ".LessonDropdownOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setAnchorEl4Lesson(event.currentTarget)
        
        // 開啟 下拉選單時，滾動到 所選擇的位置      Tim20.12.11
        // 滾動位置 Index * 元件高度
        let intOffsetTop = StateLessonIndex * 37
        let objMenuDom = mrefLessonDropdown.current.querySelector(".MuiMenu-paper")
        objMenuDom.scroll({
            top: intOffsetTop,
            left: 0
        });
    } // end of LessonDropdownOnTapHandler

    /*===========================================
    summary: 關閉Lesson 下拉選單
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function LessonDropdownCloseEventHandler()
    {
        console.log(COMP_NAME +  ".LessonDropdownCloseEventHandler")

        setAnchorEl4Lesson(null)
    } // end of LessonDropdownCloseEventHandler

    /*===========================================
    summary: 點選 Lesson 下拉選單 選項
    remarks: 000 Tim 2020/11/30 Create
    ===========================================*/
    function LessonItemOnTapHandler(StateLessonIndex, LessonIndex)
    {
        console.log(COMP_NAME + ".LessonItemOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateLessonIndex !== LessonIndex)
        {
            setLessonIndex(LessonIndex)
        }

        LessonDropdownCloseEventHandler()
    } // end of LessonItemOnTapHandler
    // ====== END Lesson下拉選單 ======
    // #endregion Other EventHandler

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        marrLessonList = []

        let objLesson = {
            PrefixName: window.gAppUI.LBL_NotSelect
        }

        marrLessonList.push(objLesson)
        marrLessonList = marrLessonList.concat(window.gSession.App.BookDef[mstrBookSeqNo].Lesson)

        console.log(COMP_NAME + ".PaintedMe BookDef: ", window.gSession.App.BookDef[mstrBookSeqNo])
        console.log(COMP_NAME + ".PaintedMe marrLessonList: ", marrLessonList)

        
        InitDataProcess(window.gSession.App.BookDef[mstrBookSeqNo])
        InitSelectedUnit(props.LessonIndex, props.SectionType, props.LUCatSeqNo)
    } // end of PaintedMe

    /*===========================================
    summary: 初始化 資料
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function InitDataProcess (BookDef)
    {
        console.log(COMP_NAME + ".InitDataProcess: BookDef: ", BookDef)

        marrPracticeButton = []
        marrReviewButton = []

        // Practice
        let intSectionIndex = 3
        let intSubSectionIndex = 0
        let intSubSectionCount = BookDef.Section[intSectionIndex].SubSection.length
        let intSubSubSectionIndex = 0
        let intSubSubSectionCount = 0

        for (intSubSectionIndex = 0; intSubSectionIndex < intSubSectionCount; intSubSectionIndex++)
        {
            console.log(COMP_NAME + ".InitDataProcess MenuName: ", BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].MenuName)

            if (
                (typeof(BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection) !== 'undefined') &&
                (BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection !== null)
                )
            {
                intSubSubSectionIndex = 0
                intSubSubSectionCount = BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection.length
                
                for (intSubSubSectionIndex = 0; intSubSubSectionIndex < intSubSubSectionCount; intSubSubSectionIndex++)
                {                    
                    AddPracticeData(SectionTypeEnum.SubSubSection
                        , BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection[intSubSubSectionIndex]
                        , AssignmentTypeEnum.Practice)
                }
            }
            else
            {
                AddPracticeData(SectionTypeEnum.SubSection
                    , BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex]
                    , AssignmentTypeEnum.Practice)
            }  
        }

        console.log("marrPracticeButton: ", marrPracticeButton)

        // Review
        intSectionIndex = 4
        intSubSectionIndex = 0
        intSubSectionCount = BookDef.Section[intSectionIndex].SubSection.length
        for (intSubSectionIndex = 0; intSubSectionIndex < intSubSectionCount; intSubSectionIndex++)
        {
            console.log(COMP_NAME + ".InitDataProcess MenuName: ", BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].MenuName)

            if (
                (typeof(BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection) !== 'undefined') &&
                (BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection !== null)
                )
            {
                intSubSubSectionIndex = 0
                intSubSubSectionCount = BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection.length
                
                for (intSubSubSectionIndex = 0; intSubSubSectionIndex < intSubSubSectionCount; intSubSubSectionIndex++)
                {
                    AddPracticeData(SectionTypeEnum.SubSubSection
                        , BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection[intSubSubSectionIndex]
                        , AssignmentTypeEnum.Review)
                }
            }
            else
            {
                AddPracticeData(SectionTypeEnum.SubSection
                    , BookDef.Section[intSectionIndex].SubSection[intSubSectionIndex]
                    , AssignmentTypeEnum.Review)
            } 
        }

        console.log("marrReviewButton: ", marrReviewButton)

        setUpdateDataTime(new Date().getTime())
    } // end of InitDataProcess

    /*===========================================
    summary: 增加 Practice / Review 元件
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function AddPracticeData (SectionType, SectionData, AssignmentType)
    {
        // console.log(COMP_NAME + ".AddPracticeData")

        let strMenuName = ""
        let intLUCatSeqNo = 0
        let blnIsShow = false
        
        if (SectionType === SectionTypeEnum.SubSection)
        {
            intLUCatSeqNo = parseInt(SectionData.LUCatSeqNo)
            strMenuName = SectionData.MenuName
        }
        else
        {
            intLUCatSeqNo = parseInt(SectionData.LUCatSeqNo)
            strMenuName = SectionData.Name
        }

        // console.log(COMP_NAME + ".AddPracticeData strMenuName: ", strMenuName)
        // console.log(COMP_NAME + ".AddPracticeData intLUCatSeqNo: ", intLUCatSeqNo)

        if (AssignmentType === AssignmentTypeEnum.Practice)
        {
            // Practice
            switch (intLUCatSeqNo)
            {
                case window.gDCPLUEnum.PracticePinyinIdentification:            // 11
                case window.gDCPLUEnum.PracticePinyinDictation:                // 12
                case window.gDCPLUEnum.PracticeFluency:                        // 28
                case window.gDCPLUEnum.PracticeListening:                      // 13
                case window.gDCPLUEnum.PracticeSpeaking:                       // 14
                case window.gDCPLUEnum.PracticeReadingComprehension:           // 15
                case window.gDCPLUEnum.PracticeWritingGrammarExercises:        // 26
                case window.gDCPLUEnum.PracticeWritingComposition:             // 18
                case window.gDCPLUEnum.PracticeActivity:                       // 19
                    blnIsShow = true
                    break

                default:
                    blnIsShow = false
                    break
            } // end of switch (intLUCatSeqNo)
        }
        else
        {
            // Review
            switch (intLUCatSeqNo)
            {
                case window.gDCPLUEnum.ReviewListening:                      // 20
                case window.gDCPLUEnum.ReviewReading:                        // 21
                case window.gDCPLUEnum.ReviewWritingGrammarExercises:        // 27
                case window.gDCPLUEnum.ReviewWritingComposition:             // 22
                case window.gDCPLUEnum.ReviewSpeaking:                       // 23
                    blnIsShow = true
                    break
                default:
                    blnIsShow = false
                    break
            } // end of switch (intLUCatSeqNo)
        }

        if (blnIsShow)
        {
            let objData = {
                "DisplayName": strMenuName,
                "LUCatSeqNo": intLUCatSeqNo,
                "IsCheck": false
            }

            if (AssignmentType === AssignmentTypeEnum.Practice)
            {
                // Practice
                marrPracticeButton.push(objData)
            }
            else
            {
                // Review
                marrReviewButton.push(objData)
            }
        }
    } // end of AddPracticeData

    /*===========================================
    summary: 取得 Lesson元件 Cls
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function InitSelectedUnit(PropsLessonIndex, PropsSectionType, PropsLUCatSeqNo)
    {
        if (PropsSectionType !== -1)
        {
            let objUnit = null
            if (PropsSectionType === AssignmentTypeEnum.Practice)
            {
                // Practice
                objUnit = marrPracticeButton.find(Unit => Unit.LUCatSeqNo === PropsLUCatSeqNo)
            }
            else
            {
                // Review
                objUnit = marrReviewButton.find(Unit => Unit.LUCatSeqNo === PropsLUCatSeqNo)
            }

            if (objUnit !== null)
            {
                objUnit.IsCheck = true
                setIsButtonCheck(true)
                setLessonIndex(PropsLessonIndex + 1)
                setUpdateDataTime(new Date().getTime())
            }

            console.log(COMP_NAME + ".InitSelectedUnit marrPracticeButton: ", marrPracticeButton)
            console.log(COMP_NAME + ".InitSelectedUnit marrReviewButton: ", marrReviewButton)
        } // end of if (PropsSectionType !== -1)
    } // end of InitSelectedUnit
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 Lesson元件 Cls
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function GetLessonUnitCls(StateLessonIndex, LessonIndex) 
    {
        let objCls = cssChooseAssignment.divLessonUnit

        if (StateLessonIndex === LessonIndex)
        {
            objCls = cssChooseAssignment.divLessonUnitSelected
        }

        return objCls
    } // end of GetLessonUnitCls

    /*===========================================
    summary: 取得 按鈕元件 Cls
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function GetButtonUnitCls(IsCheck) 
    {
        let objCls = cssChooseAssignment.divButtonUnit

        if (IsCheck)
        {
            objCls = cssChooseAssignment.divButtonUnitSelected
        }

        return objCls
    } // end of GetButtonUnitCls

    /*===========================================
    summary: 取得 按鈕元件 Check圖示 Cls
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function GetButtonUnitCheckCls(IsCheck) 
    {
        let objCls = cssChooseAssignment.divButtonUnitCheckIcon

        if (IsCheck)
        {
            objCls = cssChooseAssignment.divButtonUnitCheckSelectedIcon
        }

        return objCls
    } // end of GetButtonUnitCheckCls

    /*===========================================
    summary: 取得 按鈕元件 Check圖示 Cls
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function GetButtonUnitNameCls(IsCheck) 
    {
        let objCls = cssChooseAssignment.divButtonUnitName

        if (IsCheck)
        {
            objCls = cssChooseAssignment.divButtonUnitNameSelected
        }

        return objCls
    } // end of GetButtonUnitNameCls

    /*===========================================
    summary: 取得 確認按鈕 Cls
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function GetConfirmButtonCls(StateLessonIndex, StateIsButtonCheck)
    {
        let objCls = cssChooseAssignment.btnConfirmDisabled

        if (
            (StateLessonIndex > 0) &&
            (StateIsButtonCheck)
            )
        {
            objCls = cssChooseAssignment.btnConfirm
        }

        return objCls
    } // end of GetConfirmButtonCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Confirm Button 顯示Component  
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ComponentConfirmButton( {StateLessonIndex, StateIsButtonCheck} )
    {   
        return(
            <div className={GetConfirmButtonCls(StateLessonIndex, StateIsButtonCheck)} onClick={() => ConfirmOnTapHandler(StateLessonIndex)}>
                {window.gAppUI.BTN_Confirm}
            </div>
        )
    } // end of ComponentConfirmButton

    /*===========================================
    summary: Button Unit Content 顯示Component
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ComponentButtonUnitContent( {ButtonData} )
    {
        return (
            <>
                <div className={GetButtonUnitCheckCls(ButtonData.IsCheck)}/>
                <div className={GetButtonUnitNameCls(ButtonData.IsCheck)}>
                    {ButtonData.DisplayName}
                </div>
            </>
        )
    } // end of ComponentButtonUnitContent
                            
    /*===========================================
    summary: Title 顯示Component
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ComponentTitle( {Title} )
    {
        return (
            <div className={cssChooseAssignment.divTitle}>
                {Title}
            </div>
        )
    } // end of ComponentTitle
                    
    /*===========================================
    summary: Lesson Content 顯示Component
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ComponentLessonContent( {StateLessonIndex} )
    {
        let strLessonListText = ""

        if (marrLessonList.length > 0)
        {
            strLessonListText = marrLessonList[StateLessonIndex].PrefixName
        }
        else
        {
            strLessonListText = window.gAppUI.LBL_NotSelect
        }

        return (
            <>
                <div className={cssChooseAssignment.btnLessonIcon}/>
                <div className={cssChooseAssignment.divLessonText}>
                    {strLessonListText}
                </div>
                <div className={cssChooseAssignment.divLessonDropdownIcon}/>
            </>
        )
    } // end of ComponentLessonContent

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssChooseAssignment.btnClose} onClick={() => CloseOnTapHandler()}/>
        )
    } // end of ComponentCloseButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Review Unit 選擇
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderReviewContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return(
                <div className={cssChooseAssignment.divContent}>
                    {marrReviewButton.map((ReviewData, ReviewIndex) =>
                        <div key={ReviewIndex} className={GetButtonUnitCls(ReviewData.IsCheck)} 
                                onClick={() => ButtonUnitOnTapHandler(AssignmentTypeEnum.Review, ReviewIndex)}>
                            <ComponentButtonUnitContent ButtonData={ReviewData}/>
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderReviewContentWrapper

    /*===========================================
    summary: Render Review 
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderReviewAreaWrapper()
    {
        return(
            <div className={cssChooseAssignment.divReviewMain}>
                <ComponentTitle Title={window.gAppUI.LBL_Review}/>
                
                {RenderReviewContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderReviewAreaWrapper

    /*===========================================
    summary: Render Practice Unit 選擇
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderPracticeContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return(
                <div className={cssChooseAssignment.divContent}>
                    {marrPracticeButton.map((PracticeData, PracticeIndex) =>
                        <div key={PracticeIndex} className={GetButtonUnitCls(PracticeData.IsCheck)} 
                                onClick={() => ButtonUnitOnTapHandler(AssignmentTypeEnum.Practice, PracticeIndex)}>
                            <ComponentButtonUnitContent ButtonData={PracticeData}/>
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderPracticeContentWrapper

    /*===========================================
    summary: Render Practice Unit 選擇
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderPracticeAreaWrapper()
    {
        return(
            <div className={cssChooseAssignment.divPracticeMain}>
                <ComponentTitle Title={window.gAppUI.LBL_Practice}/>
                
                {RenderPracticeContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderPracticeAreaWrapper

    /*===========================================
    summary: Render Lesson 下拉 選單 選項
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderLessonMenuListWrapper(StateLessonIndex)
    {
        return(
            <div>
                {marrLessonList.map((LessonData, LessonIndex) =>
                    <MenuItem key={LessonIndex} className={GetLessonUnitCls(StateLessonIndex, LessonIndex)} onClick={() => LessonItemOnTapHandler(StateLessonIndex, LessonIndex)}>
                        {LessonData.PrefixName}
                    </MenuItem>
                )}
            </div>
        )
    } // end of RenderLessonMenuListWrapper

    /*===========================================
    summary: Render 選擇 Lesson 選項
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderLessonDropdownWrapper(StateLessonIndex)
    {
        return(
            <div className={cssChooseAssignment.divLesson}>
                <div className={cssChooseAssignment.btnLesson} aria-controls="menuLesson" 
                        onClick={(event) => LessonDropdownOnTapHandler(event, StateLessonIndex)}>
                    <ComponentLessonContent StateLessonIndex={StateLessonIndex} />
                </div> 

                <Menu id="menuLesson" ref={mrefLessonDropdown} anchorEl={anchorEl4Lesson} keepMounted 
                    open={(anchorEl4Lesson === null) ? false : true}
                    onClose={() => LessonDropdownCloseEventHandler()}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center'
                    }}
                    className={cssChooseAssignment.menuLesson}
                >
                    {RenderLessonMenuListWrapper(StateLessonIndex)}
                </Menu>
            </div>
        )
    } // end of RenderLessonDropdownWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderLessonDropdownWrapper(lessonIndex)}

                {RenderPracticeAreaWrapper()}
                {RenderReviewAreaWrapper()}
                
                <ComponentConfirmButton StateLessonIndex={lessonIndex} StateIsButtonCheck={isButtonCheck} />
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssChooseAssignment.divMask}>
                <div className={cssChooseAssignment.divMain}>
                    <ComponentCloseButton />

                    {RenderContentWrapper()}
                </div>
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default ChooseAssignment